
import { createClient } from "@supabase/supabase-js";

const url = process.env.REACT_APP_SUPABASE_URL;
const anon = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!url) {
  console.error(
    "Missing REACT_APP_SUPABASE_URL (put it in .env.local)"
  );
}

if (!anon) {
  console.error(
    "Missing REACT_APP_SUPABASE_ANON_KEY (put it in .env.local)"
  );
}

export const supabase = createClient(url, anon, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

// TEMPORARY: Expose Supabase for local testing only
if (
  process.env.NODE_ENV === "development" &&
  typeof window !== "undefined"
) {
  window.supabase = supabase;
}
